<!-- @format -->

<div
        class="product-card-wrapper hmf-grid hmf-span-12"
        [class]="{
                'hmf-mb-s': !isSponsored || !showNewSponsoredLabel,
                'hmf-mb-0': (isSponsored || isNikeExclusive) && showNewSponsoredLabel,
                disabled: isDisabled
        }">
        <div class="product-card-badge hmf-span-10">
                @if (badge()) {
                        <hmf-badge [badgeName]="badge()" />
                } @else if (customBadge()) {
                        <hmf-badge
                                ngSkipHydration
                                [style]="{
                                        background: 'var(' + customBadge().background + ')',
                                        color: 'var(' + customBadge().textColor + ')'
                                }"
                                [badgeName]="customBadge().text">
                        </hmf-badge>
                }
        </div>
        <div
                id="product-card"
                class="product-card-content hmf-span-12">
                <div class="inner-wrapper hmf-pb-xxs" [class.inner-wrapper--min-height]="cardMinHeight()">
                        <!-- This will be switched out for the product image component -->
                        <div class="product-card-image hmf-mt-xxs hmf-mb-xs">
                                <a
                                        role="button"
                                        class="image"
                                        tabindex="-1"
                                        aria-hidden="true"
                                        [href]="isDisabled ? 'javascript:void(0)' : updatedAssetSeoUrl"
                                        [class.disabled]="isDisabled"
                                        [title]="title"
                                        (click)="productCardClicked($event)">
                                        <span class="product-image-span hmf-display-flex hmf-justify-content-center">
                                                <homefield-product-image
                                                        #productCardImage
                                                        [imageUrl]="imageUrl"
                                                        [ecode]="ecode"
                                                        [defaultColor]="colors && colors.length > 0 ? colors[0] : null"
                                                        [productName]="title"
                                                        [selectedSwatchColor]="selectedSwatchColor"
                                                        [isLCPImage]="isLCPImage"
                                                        [isNgOptimizedImageSupported]="
                                                                isNgOptimizedImageSupported
                                                        "></homefield-product-image>
                                        </span>
                                </a>
                        </div>

                        <!-- Switch to product-swatch component -->
                        <div class="swatches-container hmf-mb-xs">
                                @if (imageSwatchesEnabled()) {
                                        <shared-totf-components-product-card-image-swatches
                                                [colors]="colors"
                                                [ecode]="ecode"
                                                [assetSeoUrl]="pdpUrl"
                                                [isLazy]="!isLCPImage"
                                                (selectedSwatchColorChange)="colorSwatchChanged($event)"
                                                (extraColorsClick)="productCardClicked($event)">
                                        </shared-totf-components-product-card-image-swatches>
                                } @else {
                                        <shared-totf-components-product-card-color-swatches
                                                [colors]="colors"
                                                [ecode]="ecode"
                                                [assetSeoUrl]="pdpUrl"
                                                [isLazy]="!isLCPImage"
                                                (selectedSwatchColorChange)="colorSwatchChanged($event)"
                                                (extraColorsClick)="productCardClicked($event)">
                                        </shared-totf-components-product-card-color-swatches>
                                }
                        </div>

                        <a
                                shared-totf-components-product-title
                                class="product-title-link hmf-subheader-m hmf-header-m-xs hmf-mb-xxs hmf-mb-m-0"
								tabindex="0"
                                [class]="{ 'favorite-product-title-link': inMauiList }"
                                [linkURL]="updatedAssetSeoUrl"
                                [title]="title"
                                [ariaLabel]="productCardAriaLabel"
                                (click)="productCardClicked($event)"
								(keydown.enter)="productCardClicked($event)">
                                {{ title }}
                        </a>

                        <ng-container *ngIf="inMauiList && !isUnavailable">
                                <div
                                        class="hmf-mt-xxs hmf-mb-xs list-attribute-container"
                                        [class]="{ 'list-attribute-container--oos': isOOS }">
                                        <div
                                                *ngIf="favoritesAttributes.length"
                                                class="hmf-display-flex hmf-flex-wrap">
                                                <ng-container
                                                        *ngFor="
                                                                let attr of favoritesAttributes | slice: 0 : 3;
                                                                let i = index;
                                                                trackBy: trackByFn
                                                        ">
                                                        <p
                                                                class="favorite-attribute label-base-subtle hmf-subheader-s hmf-mb-0 hmf-display-flex">
                                                                {{ attr.title }}: {{ attr.value
                                                                }}<span
                                                                        *ngIf="
                                                                                i !== favoritesAttributes.length - 1 ||
                                                                                (favoritesAttributes.length <= 3 &&
                                                                                        i === favoritesAttributes.length)
                                                                        "
                                                                        >,&nbsp;</span
                                                                >
                                                        </p>
                                                </ng-container>
                                                <p
                                                        *ngIf="favoritesAttributes.length > 3"
                                                        class="favorite-attribute label-base-subtle hmf-subheader-s"
														tabindex="0"
                                                        (click)="openAttributesPanel(true)"
														(keydown.enter)="openAttributesPanel(true)">
                                                        <span class="hmf-text-decoration-underline">View all details</span>
                                                </p>
                                        </div>
                                </div>
                        </ng-container>

                        @if (isOOS && !isUnavailable) {
                                <div
                                        class="oos-container"
                                        [class]="{ 'hmf-mb-m': sharedList() }">
                                        <p class="label-negative hmf-mb-0">Sorry, this item is out of stock.</p>
                                        @if (!sharedList()) {
                                                <p
                                                        class="hmf-mb-0 underline"
														tabindex="0"
                                                        (click)="ecodeSelectedEmitter()"
														(keydown.enter)="ecodeSelectedEmitter()">
                                                        Shop Similar
                                                </p>
                                        }
                                </div>
                        }

                        <ng-container *ngIf="isUnavailable">
                                <p class="label-negative product-unavailable">
                                        <homefield-icon
                                                width="20px"
                                                name="alert-info-filled"
                                                class="unavailable-icon"
                                                fill="var(--hmf-fill-negative)"></homefield-icon>
                                        Product details failed to load
                                </p>
                        </ng-container>

                        <a
                                role="button"
                                class="image"
                                tabindex="-1"
                                aria-hidden="true"
                                [href]="isDisabled ? 'javascript:void(0)' : updatedAssetSeoUrl"
                                [class.disabled]="isDisabled"
                                [title]="title"
                                (click)="productCardClicked($event)">
                                <!-- Product price, price range, was price ( see price in cart )-->
                                @if (shouldShowPricing) {
                                        <div class="product-pricing hmf-mb-xs">
                                                <hmf-price
                                                        variant="vertical"
                                                        [prices]="prices()"
                                                        [isSeePriceInCart]="mapPriceIndicator === 1"
                                                        [isClearance]="priceIndicator === 0">
                                                </hmf-price>
                                        </div>
                                }

                                <!-- Customer rating -->

                                @if (showCustomerRating) {
                                        <div
                                                class="rating-container"
                                                [class]="{'hidden': !ratingCount || !ratingValue()}">
                                                <hmf-star-ratings
                                                        [ratingCount]="ratingCount"
                                                        [ratingValue]="ratingValue()"
                                                        [showRating]="false"
                                                        [alignment]="'left'"
                                                        [showCustomerRating]="showCustomerRating && !isSponsored">
                                                </hmf-star-ratings>
                                        </div>
                                }

                                <!-- Promotion Message -->
								@if (promoMessageEnabled()) {
									<div
										class="hmf-mb-xxs promo-message">
										<shared-totf-components-promotion *ngIf="promo">
											{{ promo }}
										</shared-totf-components-promotion>
									</div>
								}

								@if (availabilityOnProductCardsEnabled) {
									<hr class="divider hmf-m-0" />
								}

                                <!-- availability component -->
                                @if (productAvailabilityData && availabilityOnProductCardsEnabled) {
                                        <common-product-availability
                                                [productAvailabilityData]="productAvailabilityData"
                                                [selectedStoreName]="selectedStoreName"
                                                [isOOS]="isOOS"
                                                [isComingSoon]="isComingSoon"></common-product-availability>
                                }
                        </a>
                        <div
                                *ngIf="!productAvailabilityData && availabilityOnProductCardsEnabled"
                                class="hmf-my-xxs availability-loader"></div>

                        @if (!isNikeExclusive) {
                                <div
                                        class="button-container hmf-display-flex hmf-justify-content-center hmf-align-items-center">
                                        @if (isComingSoon) {
                                                <button
                                                        hmf-button
                                                        class="hmf-px-0 hmf-py-0"
                                                        aria-label="Learn More"
                                                        [label]="'Learn More'"
                                                        [size]="'medium'"
                                                        [text]="'Learn More'"
                                                        [variant]="'secondary'"
                                                        (click)="productCardClicked($event)"></button>
                                        } @else {
                                                @if (isOOS || isUnavailable) {
                                                        <p class="hmf-label-l out-of-stock hmf-mb-xxxs">OUT OF STOCK</p>
                                                } @else if (productQuickViewEnabled) {
                                                        <button
                                                                hmf-button
                                                                id="add-to-cart-button"
                                                                class="hmf-px-0 hmf-py-0"
                                                                [class]="{ 'hmf-px-xs hmf-px-sm-0': chainAbbr === 'pl' }"
                                                                aria-label="Add To Cart"
                                                                [disabled]="isDisabled"
                                                                [icon]="'order-cart-standard'"
                                                                [label]="'Add To Cart'"
                                                                [loading]="false"
                                                                [size]="'medium'"
                                                                [text]="'Add To Cart'"
                                                                [variant]="'secondary'"
                                                                (click)="openQuickview()"></button>
                                                }
                                        }
                                </div>
                        } @else {
                                <div
                                        class="button-container hmf-display-flex hmf-justify-content-center hmf-align-items-center">
                                        <a
                                                homefield-button
                                                class="hmf-mx-xxxs hmf-pb-xxxs hmf-bt-xxs"
                                                variant="tertiary"
                                                [href]="learnMoreUrl">
                                                Learn More
                                        </a>
                                </div>
                        }
                        <!-- Compare checkbox -->
                        @if (compareCheckboxEnabled) {
                                <div class="compare-checkbox-container hmf-display-flex hmf-justify-content-center">
                                        <shared-totf-components-compare-checkbox
                                                class="hmf-display-flex hmf-justify-content-center"
                                                [checked]="selectedForCompare()"
                                                (tabPressed)="handleCompareTab()"
                                                (check)="handleCompareSelection($event)" />
                                </div>
                                @if (showSkipToComparisonBarButton()) {
                                        <div class="skip-to-comparison-bar-wrapper hmf-position-absolute hmf-mt-xs">
                                                <button
                                                        hmf-button
                                                        variant="secondary"
                                                        size="small"
                                                        (blur)="showSkipToComparisonBarButton.set(false)"
                                                        (click)="skipToComparisonBar($event)">
                                                        Skip to Comparison Bar
                                                </button>
                                        </div>
                                }
                        }
                </div>
        </div>
        <!-- end product card div-->

        <div
                *ngIf="(isSponsored || isNikeExclusive) && showNewSponsoredLabel"
                class="sponsored hmf-legal-s">
                Sponsored
        </div>
</div>
